import classes from "./NoteCell.module.css";
import classesCell from "./BodyCell.module.css";
import { useWorkQShell } from "../context/workQShellContext";

export default function AlertCell({ caseData, notes, workq }) {
    const shell = useWorkQShell();

    function openListPopover(rect) {
        if (!shell) return;
        shell.openPopover({
            kind: "alerts_list",
            rect,
            caseData,
            notes,
            workq,
            dismissMode: "hover-bridge",
            onPopoverMouseEnter: shell.cancelScheduledPopoverClose,
            onPopoverMouseLeave: shell.schedulePopoverClose,
        });
    }

    function openAddModal() {
        if (!shell) return;
        shell.openModal({
            kind: "modal_add_alert",
            caseData,
            workq,
        });
    }

    const hasAlerts = notes && notes.length > 0;

    return (
        <div
            className={`${classes.note_cell} ${classesCell.body_cell} ${hasAlerts ? classes.has_alerts : ""}`}
            onMouseEnter={(e) => {
                if (!shell || !hasAlerts) return;
                shell.cancelScheduledPopoverClose();
                openListPopover(e.currentTarget.getBoundingClientRect());
            }}
            onMouseLeave={() => {
                if (hasAlerts) shell?.schedulePopoverClose();
            }}
        >
            {notes && notes.length > 0 && (
                <button
                    title="alerts list"
                    type="button"
                    onClick={(e) => {
                        if (!shell) return;
                        shell.cancelScheduledPopoverClose();
                        openListPopover(e.currentTarget.getBoundingClientRect());
                    }}
                    className={`${classes.button_cell} ${classes.button_cell_with_notes}`}
                >
                    <span className={`${classes.show_notes_number}  ${notes && notes.length > 0 ? classes.button_cell_has_alerts : ""}`}>
                        {notes.length}
                    </span>
                </button>
            )}

            {(!notes || (notes && notes.length == 0)) && (
                <button title="add new alert" type="button" onClick={openAddModal} className={`${classes.button_cell} `}>
                    <span className={classes.show_notes_number}>
                        <i className="ti ti-plus"></i>
                    </span>
                </button>
            )}
        </div>
    );
}
